import {retrieveTogglesBasedOnEnvironment} from '../__vendored__/ns-feature-flags';

export const FEATURE_ENABLED_KEY = 'ns-feature-flags-vue:featureEnabled';

const flagsPromiseCache = new Map();

export const warningsEnabledByDefault = (typeof jest === 'undefined');

export async function loadFlagsWithCache({env, userId}) {
    const cacheKey = `${env}-${userId}`;
    const cached = flagsPromiseCache.get(cacheKey);
    /* istanbul ignore if */
    if (cached) {
        return cached;
    }
    const hostname = (env || '').match(/[.:]/) ? env : null;
    const promise = retrieveTogglesBasedOnEnvironment({
        hostname,
        environment: !hostname ? env : null,
        userId
    });

    flagsPromiseCache.set(cacheKey, promise);
    return promise;
}

export function clearCache() {
    flagsPromiseCache.clear();
}

/* istanbul ignore next */
export function getComponentTree(vm) {
    const nodes = [];
    let cur = vm;
    do {
        nodes.push(getComponentName(cur));
    } while (cur = cur.$parent);
    return nodes.reverse().map((each, idx) => {
        return ' '.repeat(idx * 2) + each
    }).join('\n');
}

/* istanbul ignore next */
function getComponentName(vm) {
    if (vm.$root === vm) {
        return '<Root>';
    }

    let opts = vm;
    if (typeof vm === 'function' && vm.cid !== null) {
        opts = vm.options;
    } else if (vm._isVue) {
        opts = vm.$options || vm.constructor.options;
    }

    let name = opts.name || opts._componentTag || 'Anonymous';
    return `<${name}>` + (opts.__file ? ` in ${opts.__file}` : '');
}
